import React from 'react'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/styles'
import RouterLinkButton from 'components/router-link-button'
import hasNonNullProperty from 'lib/utils/has-non-null-property'

const useStyles = makeStyles(theme => ({
  profileSection: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    padding: theme.spacing(2, 2.5),
    backgroundColor: '#E0EAFF',
    border: '1px solid #C5D4FF',
    borderRadius: 12,
    [theme.breakpoints.only('xs')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
  },
  profileCopy: {
    flex: 1,
    minWidth: 0,
  },
  profileCaption: {
    margin: 0,
    fontSize: '0.875rem',
    lineHeight: 1.5,
    color: '#172024',
  },
  profileButton: {
    alignSelf: 'flex-start',
    display: 'inline-flex',
    width: 'auto',
    borderRadius: 20,
    fontWeight: 700,
    fontSize: '0.9375rem',
    padding: theme.spacing(1, 2.5),
    whiteSpace: 'nowrap',
    flexShrink: 0,
    boxShadow: 'none',
    textTransform: 'none',
    '&:hover': {
      boxShadow: '0 4px 12px rgba(0, 83, 255, 0.28)',
    },
    [theme.breakpoints.only('xs')]: {
      alignSelf: 'stretch',
      width: '100%',
      justifyContent: 'center',
    },
  },
}))

const CompleteGolferProfileCta = ({ student, profileEditUrl }) => {
  const classes = useStyles()
  const hasCompletedProfile = hasNonNullProperty(student?.golferProfile)

  if (hasCompletedProfile) return null

  return (
    <Box className={classes.profileSection}>
      <Box className={classes.profileCopy}>
        <Typography component="p" className={classes.profileCaption}>
          Complete your golfer profile. This form will help your coach cater
          your instruction and learn more about your past golf experience.
        </Typography>
      </Box>
      <RouterLinkButton
        to={profileEditUrl}
        variant="contained"
        color="primary"
        className={classes.profileButton}
      >
        Complete Golfer Profile
      </RouterLinkButton>
    </Box>
  )
}

export default CompleteGolferProfileCta
